import type { UseQueryResult } from '@edreamsodigeo/frontend-api-client';
import { useQuery } from '@edreamsodigeo/frontend-api-client';

import type {
  FeeSelected,
  GetFlightSummarySelectedTotalPriceQuery,
  GetFlightSummarySelectedTotalPriceQueryVariables,
} from '@/generated/graphql';
import { FLIGHT_SUMMARY_SELECTED_TOTAL_PRICE } from '@/clientState/providers/operations/flightSummarySelectedTotalPrice';
import useItineraryFromUrl from '@/clientState/hooks/useItineraryFromUrl';
import { useMetaFlowProvider } from '@/clientState/providers/MetaFlowProvider';

interface FlightSummarySelectedTotalPriceProps {
  feeSelectionOverride?: FeeSelected;
}

export const useFlightSummarySelectedTotalPrice = ({
  feeSelectionOverride,
}: FlightSummarySelectedTotalPriceProps = {}): UseQueryResult<
  GetFlightSummarySelectedTotalPriceQuery,
  GetFlightSummarySelectedTotalPriceQueryVariables
> => {
  const {
    fareItineraryKey = '',
    feeSelected,
    searchId = '',
    segmentKeys = [],
    collectionMethodId,
  } = useItineraryFromUrl();
  const isMeta = useMetaFlowProvider();
  return useQuery<
    GetFlightSummarySelectedTotalPriceQuery,
    GetFlightSummarySelectedTotalPriceQueryVariables
  >(FLIGHT_SUMMARY_SELECTED_TOTAL_PRICE, {
    variables: {
      request: {
        fareItineraryKey,
        feeSelected: feeSelectionOverride || feeSelected,
        searchId: String(searchId),
        segmentKeys,
        collectionMethodId,
        isMeta,
      },
    },
  });
};
